export default {
  setMasterUpdateIndex(state, index) {
    state.masterUpdateIndex = index;
  },
  setAllMaterials(state, data) {
    state.allMaterials = data;
  },
  clearAllMaterials(state) {
    state.allMaterials = [];
  },
  setRealizations(state, data) {
    state.realizations = data;
  },
  clearRealizations(state, data) {
    state.realizations = data;
  },
};
